module.exports = __webpack_public_path__ + "static/media/galerija_2021 (24).60aa2990.jpg";